import React, { useState, useEffect } from 'react';
import { Select, Text, Grid, Paper } from '@mantine/core';

interface CustomTimePickerProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  pickupDate: Date | null;
}

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
  value,
  onChange,
  label = 'Pick time',
  required = false,
  size = 'sm',
  pickupDate
}) => {
  const [hours, setHours] = useState(value.split(/:|\s/)[0]);
  const [minutes, setMinutes] = useState(value.split(/:|\s/)[1]);
  const [error, setError] = useState('');

  useEffect(() => {
    const newTime = `${hours}:${minutes}`;
    onChange(newTime);
    if (pickupDate && hours && minutes) {
      const now = new Date();
      const selectedDateTime = new Date(pickupDate);
      selectedDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

      if (pickupDate.toDateString() === now.toDateString()) {
        if (selectedDateTime < now) {
          setError('Please select a future time');
        } else {
          setError('');
        }
      } else {
        setError('');
      }
    } else {
      setError('');
    }
  }, [hours, minutes, onChange, pickupDate]);

  const handleChange = (field: 'hours' | 'minutes', newValue: string | null) => {
    if (newValue) {
      if (field === 'hours') {
        setHours(newValue);
      } else {
        setMinutes(newValue);
      }
    }
  };

  return (
    <Paper style={{ width: '100%' }}>
      {label && (
        <Text size={size} fw={500} mb="sm">
          {label}{required && <span style={{ color: 'red' }}> *</span>}
        </Text>
      )}
      <Grid gutter="xs">
        <Grid.Col span={6}>
          <Select
            data={Array.from({ length: 24 }, (_, i) => ({ value: String(i).padStart(2, '0'), label: String(i).padStart(2, '0') }))}
            value={hours}
            onChange={(value) => handleChange('hours', value)}
            size={size}
            style={{ width: '100%' }}
            placeholder='Hours'
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <Select
            data={Array.from({ length: 60 }, (_, i) => ({ value: String(i).padStart(2, '0'), label: String(i).padStart(2, '0') }))}
            value={minutes}
            onChange={(value) => handleChange('minutes', value)}
            size={size}
            style={{ width: '100%' }}
            placeholder='Minutes'
          />
        </Grid.Col>
      </Grid>
      {error && <Text size="xs" c="red" mt="xs">{error}</Text>}
    </Paper>
  );
};

export default CustomTimePicker;